import { Input, Table } from 'antd'
import React, { useState } from 'react'
import { connect } from 'react-redux'
import { firestoreConnect, isLoaded, withFirestore } from 'react-redux-firebase'
import { Link } from 'react-router-dom'
import { withHandlers } from 'recompose'
import { compose } from 'redux'

import { removeDiacritics } from 'src/helpers/text'
import * as notificationActions from '../../actions/notifications'
import { fsCollections } from '../../helpers/firestore'
import routes from '../../helpers/routes'
import { playerColumns } from '../../shared/columns'
import { DeleteButtonWithConfirmation } from '../ActionWithConfirmation'
import authorize from '../higher-order/authorize'

const PlayerList = ({ tenant, players, deletePlayer }) => {
  const columnConfig = [
    playerColumns.nationality,
    {
      title: 'Player',
      key: 'fullName',

      render: (text, record) => (
        <Link
          to={routes.editPlayer(
            tenant,
            record.id,
          )}>{`${record.lastName} ${record.firstName}`}</Link>
      ),
    },
    {
      key: 'delete',
      /* TODO should be aligned to right */
      width: '2em',
      render: (text, record) => {
        const deletePlayerAction = () => deletePlayer(record.id)

        return (
          <DeleteButtonWithConfirmation
            title="Are you sure to delete this player?"
            popupPlacement="left"
            onConfirmAction={deletePlayerAction}
          />
        )
      },
    },
  ]

  const [searchString, setSearch] = useState<string>('')

  const filteredPlayers = players
    ? players.filter((player) =>
        removeDiacritics(`${player.lastName} ${player.firstName}`.toLowerCase()).includes(
          removeDiacritics(searchString.toLowerCase()),
        ),
      )
    : undefined

  return (
    <div className="PlayerList">
      <Input.Search
        placeholder="Search"
        // tslint:disable-next-line:jsx-no-lambda
        onChange={(event) => setSearch(event.target.value)}
      />
      <Table
        dataSource={filteredPlayers}
        columns={columnConfig}
        rowKey="id"
        loading={!isLoaded(players)}
        size="small"
        pagination={false}
      />
    </div>
  )
}

export default compose<FIXME>(
  authorize('admin'),
  withFirestore,
  firestoreConnect<FIXME>(({ tenant }) => [
    {
      collection: fsCollections.globalPlayers(tenant),
      orderBy: [['nationality'], ['lastName'], ['firstName']] as FIXME,
    },
  ]),
  withHandlers({
    deletePlayerSuccess: ({ dispatch }) => () => {
      dispatch(notificationActions.notifySuccess('Player deleted'))
    },
    deletePlayerFailure: ({ dispatch }) => (err) => {
      // tslint:disable-next-line:no-console
      console.error(err)
      dispatch(notificationActions.notifyFailure('Failed to delete player'))
    },
  }),
  withHandlers({
    deletePlayer: ({ firestore, tenant, deletePlayerSuccess, deletePlayerFailure }) => (playerId) =>
      firestore
        .delete({ collection: fsCollections.globalPlayers(tenant), doc: playerId })
        .then(deletePlayerSuccess)
        .catch(deletePlayerFailure),
  }),
  connect(({ firestore }: FIXME, { tenant }: FIXME) => ({
    players: firestore.ordered[fsCollections.globalPlayers(tenant)],
  })),
)(PlayerList)



// WEBPACK FOOTER //
// ./src/components/players/PlayerList.tsx